export default () => ({
    visible: true,
    init() {
        if (document.cookie.includes('isHidden')) 
            this.visible = false
    },
    close() {
        this.visible = false
        this.setCookie('isHidden', 'true', 30)
    },
    root: {
        ['x-ref']: 'root',
        ['x-show']: 'visible',
        ['x-cloak']: '',
        ['x-transition:leave']: 'cookie-banner--leave',
        ['x-transition:leave-start']: 'cookie-banner--leave-start',
        ['x-transition:leave-end']: 'cookie-banner--leave-end',
    },
    hide: {
        ['@click']: 'close()'
    },
    setCookie(name, value, days) {
        const expires = new Date(Date.now() + days * 864e5).toUTCString()
        document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/'
    }
})